import { BrowserRouter as HashRouter } from 'react-router-dom'
import OptumMatch from './OptumMatch'
import createUesTheme from './theme'
import { GlobalStyles, ThemeProvider } from '@mui/material'
import { QueryClient, QueryClientProvider } from 'react-query'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { ProviderAuthProvider } from '@provider/context/AuthContext'
import ToastManager from '@context/ToastManager'
import UserContext from '@context/UserContext'
import GlobalContextProvider from '@context/GlobalContext'
import { PatientAuthProvider } from '@patient/context/AuthContext'
import BreadcrumbProvider from '@context/BreadCrumbContext'
import SurveyModalProvider from '@context/SurveyModalContext'
import { withLDProvider } from 'launchdarkly-react-client-sdk'
import ToastProvider from '@common/CustomToast'
import { AdminAuthProvider } from '@admin/context/AdminProvider'
import OrganizationProvider from '@admin/OrganizationContext'
import { getLaunchDarklyClientId } from '@util/ldClientId'

const ldClientIdValue: string = getLaunchDarklyClientId()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      cacheTime: Infinity,
    },
    mutations: {
      retry: false,
    },
  },
})
const optumTheme = createUesTheme()
const App = () => {
  return (
    <HashRouter>
      <ThemeProvider theme={optumTheme}>
        <GlobalStyles
          styles={(theme) => ({
            ':root': {
              '--theme-font-family': theme.typography.fontFamily,
            },
          })}
        />
        <GlobalContextProvider>
          <QueryClientProvider client={queryClient}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <ToastManager>
                <ToastProvider>
                  <UserContext>
                    <AdminAuthProvider>
                      <ProviderAuthProvider>
                        <PatientAuthProvider>
                          <BreadcrumbProvider>
                            <SurveyModalProvider>
                              <OrganizationProvider>
                                <OptumMatch />
                              </OrganizationProvider>
                            </SurveyModalProvider>
                          </BreadcrumbProvider>
                        </PatientAuthProvider>
                      </ProviderAuthProvider>
                    </AdminAuthProvider>
                  </UserContext>
                </ToastProvider>
              </ToastManager>
            </LocalizationProvider>
          </QueryClientProvider>
        </GlobalContextProvider>
      </ThemeProvider>
    </HashRouter>
  )
}

export default withLDProvider({
  clientSideID: ldClientIdValue,
  options: {
    bootstrap: 'localStorage',
  },
})(App)
